import { memo } from "react";

const AudioPreview = ({ file }) => {
  return <audio controls src={URL.createObjectURL(file)} />;
};

export default memo(AudioPreview);
